import { GetApiPayloadByUrl, GetApiResponseByUrl } from '@crossbeam/openapi';

import {
  BILLING_TIERS,
  CORE_SEAT_COMPONENTS,
  SALES_SEAT_COMPONENTS,
} from '@/constants/billing';

export type CoreSeatComponent =
  (typeof CORE_SEAT_COMPONENTS)[keyof typeof CORE_SEAT_COMPONENTS];
export type SalesSeatComponent =
  (typeof SALES_SEAT_COMPONENTS)[keyof typeof SALES_SEAT_COMPONENTS];

export type PortalInfo = GetApiResponseByUrl<
  '/v0.2/billing/portal/sync',
  'post'
>;

export type PurchaseConnectorPayload = GetApiPayloadByUrl<
  '/v0.2/billing/subscriptions/{product_handle}',
  'post'
>;
export type PurchaseConnectorResponse = GetApiResponseByUrl<
  '/v0.2/billing/subscriptions/{product_handle}',
  'post'
>;
export type EditConnectorResponse = GetApiResponseByUrl<
  '/v0.2/billing/subscriptions/{product_handle}',
  'put'
>;

export type PurchaseComponentsResponse = GetApiResponseByUrl<
  '/v0.2/billing/subscription/components',
  'post'
>;

export type PreviewComponentsResponse = GetApiResponseByUrl<
  '/v0.2/billing/subscription/components/preview',
  'post'
>;
export type PreviewComponent = PreviewComponentsResponse['components'][number];

export type PreviewConnectorResponse = GetApiResponseByUrl<
  '/v0.2/billing/subscriptions/{product_handle}/preview',
  'post'
>;
export type PreviewConnectorPayload = GetApiPayloadByUrl<
  '/v0.2/billing/subscriptions/{product_handle}/preview',
  'post'
>;
export type PreviewProduct = PreviewConnectorResponse['products'][number];

export type PaymentInfo = GetApiResponseByUrl<'/v0.2/billing/payment'>;

export type BillingInfo = GetApiResponseByUrl<'/v0.2/billing/sync', 'post'>;
export type BillingTier = (typeof BILLING_TIERS)[keyof typeof BILLING_TIERS];
export type ChargifyComponent = NonNullable<
  BillingInfo['chargify_subscription']
>['components'][number];
export type PricePoint = ChargifyComponent['price_points'][number];

type PostSubscriptionPayload = GetApiPayloadByUrl<
  '/v0.2/billing/subscription/components',
  'post'
>;
export type PostSubscriptionComponent =
  PostSubscriptionPayload['components'][number];

export type CancelSubscriptionPayload = GetApiPayloadByUrl<
  '/v0.2/billing/subscriptions/{product_handle}/cancellation',
  'post'
>;

export type ReclaimSeatsPayload = GetApiPayloadByUrl<
  '/v0.2/billing/subscriptions/components/reclaim',
  'patch'
>;
export type ReclaimSeatsComponent = ReclaimSeatsPayload['components'][number];

export type ReduceComponentsPayload = GetApiPayloadByUrl<
  '/v0.2/billing/subscriptions/components/reduce',
  'post'
>;

export type BillingInteraction = {
  cta?: string;
  cta_2?: string;
  talkToSalesReason?: string;
  event_site: string;
  seatType?: string;
  isEarlyAdopter?: boolean;
  period?: string;
  number_of_seats?: number;
  attribution_credits?: string;
};

export type BillingQuery = {
  cancelDestination: string;
  userIds?: string[];
  emails?: string[];
} | null;

export enum BillingPeriod {
  Month = 'month',
  Year = 'year',
}
